<div class="banner_header">
    <div class="col-md-12">
        <h2 style="margin-bottom: 0px;">Invigilator Dashboard</h2>
    </div>
</div>

<div class="d-flex" id="wrapper" style="min-height: 500px;">
    <!-- Sidebar-->
    <div class="bg-light border-right col-md-2" id="sidebar-wrapper">
        <div class="list-group list-group-flush">
            <a class="list-group-item list-group-item-action bg-light"
                routerLink="/invigilator_dashboard/invigiericount">Dashboard</a>
            <!-- <a class="list-group-item list-group-item-action bg-light" routerLink="/dashboard/eriedit"
          routerLinkActive="active"> Edit </a> -->
            <a class="list-group-item list-group-item-action bg-light" routerLink="/invigilator_dashboard/eriform"
                routerLinkActive="active"> ERI </a>
            <a class="list-group-item list-group-item-action bg-light" routerLink="/invigilator_dashboard/eristatus"
                routerLinkActive="active"> Track ERI </a>
            <!-- <a class="list-group-item list-group-item-action bg-light" routerLink="/dashboard/eristatus"
          routerLinkActive="active"> Status </a> -->
            <a class="list-group-item list-group-item-action bg-light" (click)="logout()"> Logout </a>
        </div>
    </div>
    <!-- Page Content-->
    <div class="col-md-10" id="page-content-wrapper" style="width: 100%">
        <div class="username_cls" style="text-align: right; font-size: 16px; padding: 10px;">
            <span> <i class="fa fa-user" aria-hidden="true"></i> {{invigilator_name}} </span>
            <span> <i class="fa fa-cog" aria-hidden="true"></i> {{invigilator_role}} </span>
        </div>
        <router-outlet></router-outlet>
    </div>
</div>